import { FC } from 'react';
import { Modal } from '@dynamika-shared/ui/Modal/Modal';

type ClinicalTrialActivateModalProps = {
  onCancel?: () => void;
  onConfirm?: () => void;
  open: boolean;
};
 
export const ClinicalTrialActivateModal: FC<
  ClinicalTrialActivateModalProps
> = ({ open, onCancel, onConfirm }) => {
  return open ? (
    <Modal
      width={440}
      onCancel={onCancel}
      onOk={onConfirm}
      okText='Activate'
      centered
      cancelText='Cancel'
      maskClosable={true}
      open={open}
      mask={true}
      title='Clinical Trial Activation'
      titleClassName='text-left'
      data-testid={'unsaved-chan  ges-popup'}
    >
      Activating the trial will make it accessible to all users, allowing them
      to start working on it immediately.
      <br />
      Please confirm that you want to activate the trial.
    </Modal>
  ) : null;
};
